import {useSearchParams} from 'react-router'
import TripListing from '@/customComponents/uiComponents/global/TripListing.jsx'
import RideTabNav from '@/customComponents/uiComponents/global/RideTabNav.jsx'
import {useCancelledTrips} from '@/hooks/useTrips'

export default function CancelledRides() {
    const [searchParams, setSearchParams] = useSearchParams()
    const page = Math.max(1, parseInt(searchParams.get('page'), 10) || 1)
    const setPage = (next) => {
        const params = new URLSearchParams(searchParams)
        if (next > 1) params.set('page', String(next))
        else params.delete('page')
        setSearchParams(params, {replace: true})
    }
    // isPlaceholderData (true only while switching pages) drives the fade — NOT
    // isFetching, which the 1s background poll would flip every second and pulse the list.
    const {data, isLoading, isPlaceholderData} = useCancelledTrips({page})

    return (
        <div className="flex flex-col gap-5 max-md:gap-3">
            <h2 className="max-md:hidden">Cancelled Rides</h2>
            <RideTabNav/>
            <TripListing
                trips={data?.trips || []}
                heading="Cancelled Rides"
                showDark={false}
                rideType="cancelled"
                isLoading={isLoading}
                isFetching={isPlaceholderData}
                pagination={data?.pagination}
                page={page}
                onPageChange={setPage}
            />
        </div>
    )
}
